/**
 *  An error that occurred while the SDK made a request to the shop API.
 */
export default class ApiError extends Error {
    /**
     *  @internal Used to construct ApiErrors
     */
    constructor(error) {
        super((error && error.message) || 'Unknown error');
        /**
         *  The name of the error.
         */
        this.name = 'ApiError';
        if (error) {
            this.response = error.response;
        }
        // noinspection SuspiciousTypeOfGuard
        this.statusCode = (this.response && typeof this.response.status === 'number') ? this.response.status : 500;
        // Get the description from the most logical place(s)
        if (this.response && typeof this.response.data === 'string') {
            this.description = this.response.data;
        }
        else if (this.response && this.response.data && this.response.data.error_description) {
            this.description = this.response.data.error_description.message ? this.response.data.error_description.message : this.response.data.error_description;
        }
        else if (this.response && this.response.statusText) {
            this.description = this.response.statusText;
        }
        if ((typeof this.description === 'string' || Array.isArray(this.description))) {
            this.description = this.description.length > 0 ? this.description : 'Unknown error';
        }
        else if (typeof this.description === 'object' && !Object.getOwnPropertyNames(this.description).length) {
            this.description = 'Unknown error';
        }
        // Ensure some error description is given
        if (!this.description) {
            this.description = this.message;
        }
    }
}
//# sourceMappingURL=api.error.js.map